var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{ref:"masterMain",attrs:{"addProperties":{
    eventType: 1,
    routeToCreate: _vm.getModuleRoute,
  },"exportProperties":{
    pdf: {
      filename: `${_vm.$t(
        'production.category_rejection_cause'
      )}_${_vm.dateToday}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t(
        'production.category_rejection_cause'
      )}_${_vm.dateToday}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  },"dataBadges":[
    {
      columnLabel: _vm.$t('common_words.crops'),
      data: 'crops',
      property: 'name',
      minWidth: 120,
    },
    {
      columnLabel: _vm.$t('common_words.associated_companies2'),
      data: 'businesses',
      property: 'name',
      minWidth: 160,
    },
  ],"route":_vm.getModuleRoute,"tableProperties":_vm.tableProperties,"showSubcategories":true},on:{"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}})
}
var staticRenderFns = []

export { render, staticRenderFns }